<template>
  <div class="distribution">
    <el-input class="search-el" size="mini" v-model="query.title" clearable placeholder="分销标题"></el-input>
    <el-select class="search-el" size="mini" v-model="query.run_state" clearable>
      <el-option label="全部" :value="null">全部</el-option>
      <el-option label="未开始" :value="1">未开始</el-option>
      <el-option label="进行中" :value="2">进行中</el-option>
      <el-option label="已结束" :value="3">已结束</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
    <el-button type="primary" size="mini" @click="toCreate()"> 添加活动</el-button>
    <el-row>
      <el-table v-loading="loading" :data="tableData" border size="mini" :stripe="true"
        style="width: 100%; margin: 10px 0">
        <el-table-column label="分销标题" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <div>{{ row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column label="起止日期" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <span>{{ row.begin_at }}</span>至<span>{{ row.end_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="今日打开人数" align="center" min-width="3%">
          <template slot-scope="{ row }">
            <div @click="$router.push(`/distribution/opennumberpeople?id=${row.id}`)" style="color: #409eff;">{{
      row.visit_num }}</div>
          </template>
        </el-table-column>
        <el-table-column label="今日分享人数" align="center" min-width="3%">
          <template slot-scope="{ row }">
            <div @click="$router.push(`/distribution/sharepeople?id=${row.id}`)" style="color: #409eff;">{{ row.share_num
              }}</div>
          </template>
        </el-table-column>
        <el-table-column label="今日发放金额" align="center" min-width="3%">
          <template slot-scope="{ row }">
            <div @click="$router.push(`/distribution/withdraw?id=${row.id}`)" style="color: #409eff;">{{ row.rebate_amount
              }}</div>
          </template>
        </el-table-column>
        <el-table-column label="关联课程" align="center" min-width="3%">
          <template slot-scope="{ row }">
            <div @click="$router.push(`/distribution/relevance?id=${row.id}`)" style="color: #409eff;">{{ row.relation_num
              }}</div>
          </template>
        </el-table-column>
        <el-table-column label="活动图片" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div style="object-fit: cover; width: 100%; height: 110px;"><img :src="row.img_url" alt=""
                style="width: 100%; height: 100%;"></div>
          </template>
        </el-table-column>
        <el-table-column label="活动链接" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button  @click.stop="examineHandel(row.url)" type="primary">查看链接</el-button>
            <!-- <img :src="row.avatar" style="width: 40px;" alt="" /> -->
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" min-width="2%">
          <template slot-scope="{ row }">
            <div>{{ row.run_state == 1 ? '未开始' : row.run_state == 2 ? '进行中' : '已结束' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="4%">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click.stop="updateHandel(row.id, row.status)">
              <div>{{ row.status ? '下架' : '发布' }}</div>
            </el-button>
            <el-button type="text" size="mini" @click="DetailHandel(row.id)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="活动链接" :visible.sync="dialogVisible3" width="50%">
      <el-input v-model="liveURL" style="width:66%; margin-left: 256 /2; position: relative; left: 10%;"></el-input>
      <el-button  type="primary" size="mini" @click="copy(liveURL)" style="position: absolute; right: 10%; margin-top: 6px;">复制</el-button>
      <div id="qrcode"></div>
    </el-dialog>
  </div>
</template>

<script>

import { getindexlist, updateStatus } from "@/api/distribution";
import { qrCode, copyData } from "@/api/common";
export default {
  data() {
    return {
      query: {
        title: '',
        run_state: null,
      },
      tableData: [],
      loading: false,
      liveURL: '',
      dialogVisible3: false
    }
  },
  mounted() {
    this.loading = false
    this.getList()
  },
  methods: {
    getList() { // 查询列表
      getindexlist(this.query).then((res) => {
        console.log(res);
        this.tableData = res.data.list
      })
    },
    toCreate() { // 添加活动
      this.$router.push('/distribution/created_activity')
    },
    updateHandel(id, status) { // 发布
      let text = ''
      if (status) { status = 0, text = '下架' } else { status = 1, text = '发布' }
      console.log('xiajai', status);
      updateStatus({ id, status }).then((res) => {
        if (res.code) {
          this.getList()
          this.$message({
            message: text + res.message,
            type: 'success'
          });
        }
      })
    },
    DetailHandel(id) { //详情
      this.$router.push(`/distribution/created_activity?id=${id}`)
    },
    handleRowClick(row, event, clomumn) {
      console.log(row);

    },
    examineHandel(url) {
      this.liveURL = url
      this.dialogVisible3 = true;
      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        // this.liveURL = response.data.url;
        let qrcode = qrCode(url, 300, 300);
      });
    },
    copy(url) {
      copyData(url)
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
  },
}
</script>

<style>
.distribution {
  cursor: pointer;
}

.distribution .activelink {
  height: 110px;
  display: flex;
  align-items: center;
}
.distribution #qrcode{
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
</style>